<template>
  <div class="home">
    <!-- <h2>这是home.vue页面</h2> -->
    <div id="MyViewerDiv"></div>
  </div>
</template>

<script>
import { GetModelInfo } from "@/setAxios";
export default {
  name: "viewModel",
  components: {},
  data() {
    return {
      url: "",
      locationParams: {}
    };
  },
  props: ["selectId"],
  methods: {
    viewers(url) {
      var viewer;
      //初始化
      var myViewerDiv = document.getElementById("MyViewerDiv");
      var config = {
        extensions: [
          "Autodesk.Viewing.ZoomWindow",
          // "Autodesk.Viewing.Collaboration"
        ],
        disabledExtensions: {
          measure: false,
          section: false
        },
        memory: {
          limit: 32 * 1024 //32 GB
        }
      };
      viewer = new Autodesk.Viewing.Private.GuiViewer3D(myViewerDiv, config);
      var url = url;
      var options = {
        document: url,
        env: "Local",
        offline: "true",
        useADP: false
      };
      EaBIM.DataLoading();
      Autodesk.Viewing.Initializer(options, function onInitialized() {
        viewer.setTheme("light-theme");
        viewer.start(
          options.document,
          options,
          onLoadModelSuccess,
          onLoadModelError
        );

        viewer.addEventListener(
          Autodesk.Viewing.GEOMETRY_LOADED_EVENT, //!<<<< 事件名称
          function(event) {
            layer.closeAll("loading");
            $(".adsk-icon-live-review").click();
          }
        );
      });

      //加载成功返回函数
      function onLoadModelSuccess(model) {
        //("Validate model loaded: " + (viewer.model === model));
        //(model);
      }

      //加载失败返回函数
      function onLoadModelError(viewerErrorCode) {
        console.error("onLoadModelError() - errorCode:" + viewerErrorCode);
      }
    }
  },
  watch: {
    selectId(val) {
      //(val);
    }
  },
  created() {
    var _this = this;
    var search = window.location.hash
      .substr(1)
      .split("&")[0]
      .split("=")[1]
      .replace(/%3D/g, "=");
    search = Base64.decode(search).split("&")[0];
    this.url = search;
  },
  mounted() {
    this.viewers(this.url);
  }
};
</script>

<style lang="less">
#toolbar-collaborateTool {
  display: none !important;
}
</style>
